import dotProp from 'dot-prop-immutable'
import Persist from '@services/persist'
import { CurrentEntityPersist, InitialConfig } from '@loctypes'

interface GetConfig {
  (key?: undefined): InitialConfig

  <K extends keyof InitialConfig>(key: K): InitialConfig[K]
}

export const getConfig: GetConfig = (key?: keyof InitialConfig) => {
  let config
  if (window.flomniConfig) {
    // new way
    config = window.flomniConfig
  } else if (window.flomni) {
    // @deprecated
    config = window.flomni
  } else {
    throw new Error('there is no "window.flomniConfig"')
  }

  if (key) {
    return dotProp.get(config, key, null)
  } else {
    return config
  }
}

export const getWindow = (whatType?: string): Window => {
  let totalType
  const { entity } = Persist.memory.get<CurrentEntityPersist>('widgetType')

  if (whatType) {
    totalType = whatType
  } else if (entity === 'chat.corner') {
    totalType = 'pager'
  } else if (entity === 'chat.messages') {
    totalType = 'pager'
  } else if (entity === 'chat.embedded') {
    totalType = 'embedded'
  }

  const selector = `[name^="flomni:${totalType}"]`
  const frame = document.querySelector(selector) as HTMLFrameElement

  return frame.contentWindow!
}

export const getDocument = (whatType?: string): Document => {
  return getWindow(whatType).document
}
